type SyncCallback = (sessionId: string, messages: any[]) => void;

let broadcastChannel: BroadcastChannel | null = null;
let storageListenerActive = false;

export function initCrossTabSync(onSync: SyncCallback): void {
  try {
    broadcastChannel = new BroadcastChannel('bongai-agent-sync');
    broadcastChannel.onmessage = (event) => {
      const { type, sessionId, messages } = event.data || {};
      if (type === 'agent-update' && sessionId) {
        onSync(sessionId, messages);
      }
    };
  } catch {}

  if (!storageListenerActive) {
    try {
      window.addEventListener('storage', (e) => {
        if (e.key === 'bongai_agent_broadcast' && e.newValue) {
          try {
            const data = JSON.parse(e.newValue);
            if (data.type === 'agent-update' && data.sessionId) {
              onSync(data.sessionId, data.messages);
            }
          } catch {}
        }
      });
      storageListenerActive = true;
    } catch {}
  }
}

export function notifyOtherTabs(sessionId: string, messages: any[]): void {
  try {
    if (broadcastChannel) {
      broadcastChannel.postMessage({ type: 'agent-update', sessionId, messages });
    } else {
      localStorage.setItem('bongai_agent_broadcast', JSON.stringify({
        type: 'agent-update', sessionId, messages, timestamp: Date.now()
      }));
      localStorage.removeItem('bongai_agent_broadcast');
    }
  } catch {}
}
